import { AppState } from '../../bootstrap/redux/state/AppState';
import { DisplaySettings } from '../state/DisplaySettingsState';

export function selectDisplaySettings(state: AppState): DisplaySettings {
  return state.displaySettings;
}
